import searchPlugin from '@backstage/plugin-search/alpha';

/**
 * Search plugin with custom page override.
 * Native page:search is re-enabled with custom search result types and filters.
 */
const searchFeature = searchPlugin.withOverrides({
  extensions: [
    searchPlugin.getExtension('page:search').override({
      factory(originalFactory) {
        return originalFactory({
          params: {
            path: '/search',
            noHeader: true,
            loader: async () => {
              const { searchPage } = await import(
                '../components/search/SearchPage'
              );
              return searchPage;
            },
          },
        });
      },
    }),
  ],
});

export default searchFeature;
